import styles from "./ConsultingDetail.module.css";
import SubPageTop from "../../components/SubPageTop";
import ScrollReveal from "../../components/Ui/ScrollReveal";
import { FiFolder, FiSearch, FiDroplet, FiCheckCircle } from 'react-icons/fi';

const brandProcessData = [
  {
    id: 1,
    number: "01",
    title: "기업 분석",
    icon: FiFolder,
    items: [
      "기업 핵심가치, 브랜드 목표, 대상 고객, 특성 분석",
      "브랜드 맞춤형 색 구성표 후보 선정"
    ]
  },
  {
    id: 2,
    number: "02",
    title: "리서치",
    icon: FiSearch,
    items: [
      "소비자 컬러 선호도 조사 및 분야별 컬러 트렌드 파악",
      "경쟁사 브랜드 색상 비교"
    ]
  },
  {
    id: 3,
    number: "03",
    title: "컬러 팔레트 구성",
    icon: FiDroplet,
    items: [
      "차별화를 위한 맞춤 컬러 솔루션 개발, 수우권 제공",
      "색상, 채도, 명도에 따른 색상코드 보고서 제공"
    ]
  },
  {
    id: 4,
    number: "04",
    title: "컬러디자인 적용",
    icon: FiCheckCircle,
    items: [
      "로고, CI, BI, 웹사이트, 소셜 미디어, 유니폼 등 컬러 디자인 적용 결과를 검수"
    ]
  }
];

function EnterpriseBrandIdentity() {
  return (
    <div className={styles.consultingDetail}>
      <SubPageTop title="Consulting" />
      <div className={styles.consultingDetailContent}>
        <ScrollReveal>
          <section className={styles.section01}>
          <div className={styles.imgbox}>
            <img
              src="/image/consulting-detail-section01-03.png"
              alt="컬러 이미지"
            />
          </div>
          <div className={styles.infoBox}>
            <div className={styles.infoHeader}>
              <p className={styles.subtitle}>Color Consulting</p>
              <p className={styles.koTitle}>브랜드 아이덴티티 컨설팅</p>
            </div>
            <div className={styles.infoDetail}>
              <div className={styles.infoDesc}>
                브랜드 컬러디자인은,
                <br />
                브랜드를 위한 맞춤형 컬러솔루션을 제안하여 차별화된 마케팅을 할
                수 있도록 구성합니다.
              </div>
              <ul className={styles.infoList}>
                <li>
                  <span className={styles.pointcolor}>·</span>
                  <span>
                  기업의 경쟁력을 높일 수 있도록 BI, CI 메인 컬러 선정과 적용 방법
                  제안
                  </span>
                </li>
                <li>
                  <span className={styles.pointcolor}>·</span>
                  <span>
                  컬러를 전략적 자산으로 활용하여 고객에게 독보적인 인상을
                  심을 수 있는 컬러 의미 반영
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        </ScrollReveal>
        <ScrollReveal>
          <section className={styles.section02}>
            <div className={styles.titleWrap}> 
                <p className={styles.programSubtitle}>process</p>
                <h2 className={styles.title}>컨설팅 프로세스</h2>
            </div>
            <div className={styles.line}></div>
            <div className={styles.brandIdentityWrapper}>
            <div className={styles.brandIdentityGrid}>
              {brandProcessData.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={item.id} className={styles.brandIdentityCard}>
                    <div className={styles.brandIdentityCardHeader}>
                      <h3 className={styles.brandIdentityNumber}>{item.number}</h3>
                      <h4 className={styles.brandIdentityTitle}>{item.title}</h4>
                    </div>
                    <div className={styles.brandIdentityCardBody}>
                      <ul className={styles.brandIdentityList}>
                        {item.items.map((text, idx) => (
                          <li key={idx}>{text}</li>
                        ))}
                      </ul>
                    </div>
                    <div className={styles.brandIdentityIconWrapper}>
                      <Icon className={styles.brandIdentityIcon} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        </ScrollReveal>
      </div>
    </div>
  );
}

export default EnterpriseBrandIdentity;
